export default "/assets/images/mila-filter-video-1.b8a1b4f10d09c960.mp4";